var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter-component"
  }, [_c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "d-flex align-center mb-2"
  }, [_c('h3', {
    staticClass: "text-subtitle-1 font-weight-medium mr-2"
  }, [_vm._v("Filters")]), _c('v-spacer'), _vm.localFilters.length > 0 ? _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "x-small": ""
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v(" Clear all ")]) : _vm._e()], 1), _vm._l(_vm.localFilters, function (condition, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2"
    }, [_c('filter-condition', {
      attrs: {
        "condition": condition,
        "fields": _vm.fields,
        "used-fields": _vm.getUsedFieldsExcept(index)
      },
      on: {
        "update:condition": function updateCondition($event) {
          return _vm.updateCondition(index, $event);
        },
        "remove": function remove($event) {
          return _vm.removeCondition(index);
        }
      }
    })], 1);
  }), _c('div', {
    staticClass: "d-flex align-center mt-3"
  }, [_c('v-btn', {
    staticClass: "px-0",
    attrs: {
      "color": "primary",
      "text": "",
      "small": "",
      "disabled": _vm.areAllFieldsUsed()
    },
    on: {
      "click": _vm.addCondition
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add filter ")], 1), _c('v-spacer'), _vm.localFilters.length > 0 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "disabled": _vm.localFilters.length === 0
    },
    on: {
      "click": _vm.applyFilters
    }
  }, [_vm._v(" Apply ")]) : _vm._e()], 1)], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }